$( ".more-testimonials-button" ).click(function() {
    $(".more-testimonials").fadeIn(300);
    $(".more-testimonials-button").addClass("hide");
});